module.exports = __webpack_public_path__ + "img/res.b5811c16.png";